import { z } from "zod"

export const mapPinCommentContextSchema = z.object({
    target: z.literal("map-pin"),
})

export const mapCommentReplyContextSchema = z.object({
    target: z.literal("map-comment"),
})

export type MapPinCommentContext = z.infer<typeof mapPinCommentContextSchema>
export type MapCommentReplyContext = z.infer<typeof mapCommentReplyContextSchema>
